import { ICSSInJSStyle } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../shared/theme/useColorScheme";
interface PrivacyFooterStyles {
  privacyFooter: ICSSInJSStyle;
}

export const usePrivacyFooterStyles: () => PrivacyFooterStyles = () => {
  const { main } = useFluentColorScheme();

  return {
    privacyFooter: {
      color: main.foreground1,
      textDecoration: "underline",
    },
  };
};
